import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { reportScreenView } from "./index";
import { createScreenTracker, REDIRECT_WAIT_MS } from "./screens";

const tracker = createScreenTracker(reportScreenView, {
  redirectWaitMs: REDIRECT_WAIT_MS,
});

// Reports an Atlas screen view whenever the hash route path changes.
const useScreenTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    tracker(pathname);
  }, [pathname]);
};

export default useScreenTracking;
